<template>
	<div class="new-home">
		<!-- 顶部导航 -->
		<top-nav-head />

		<main class="new-home__main">
			<!-- Banner 轮播 -->
			<section class="banner-section" aria-label="首页轮播图">
				<div ref="bannerSwiper" class="swiper-container">
					<div class="swiper-wrapper">
						<div v-for="(item, index) in bannerList" :key="index" class="swiper-slide">
							<div
								class="banner-content"
								:style="{ backgroundImage: `url(${item.imageUrl})` }"
								role="img"
								:aria-label="item.title"></div>
						</div>
					</div>
					<div class="swiper-button-prev"></div>
					<div class="swiper-button-next"></div>
				</div>
			</section>

			<div class="new-home__content">
				<!-- 数据统计 -->
				<section class="statistics-section" aria-labelledby="statistics-title">
					<div class="statistics-section__heading">
						<div>
							<p class="statistics-section__eyebrow">DATA OVERVIEW</p>
							<h2 id="statistics-title">平台数据</h2>
						</div>
						<span>用数据洞察行业，用服务助力发展</span>
					</div>
					<ul class="statistics-list">
						<li v-for="item in statisticsList" :key="item.key" class="statistics-item">
							<div :class="['statistics-item__icon', `statistics-item__icon--${item.key}`]">
								<i :class="['iconfont', item.icon]" aria-hidden="true"></i>
							</div>
							<div class="statistics-item__content">
								<p class="statistics-item__label">{{ item.label }}</p>
								<div class="statistics-item__number">
									<count-to :start-val="0" :end-val="item.value" :duration="1800" separator="," />
									<span class="statistics-item__unit">{{ item.unit }}</span>
								</div>
							</div>
						</li>
					</ul>
					<!-- <p class="statistics-section__source">*以上数据来源于楚建通服务团队于2026-08-07全量统计，此数据将定期更新</p> -->
				</section>

				<!-- 服务能力 -->
				<section class="service-capability-section" aria-labelledby="service-capability-title">
					<h2 id="service-capability-title">总有一款服务，满足您的业务需求</h2>
					<div class="service-capability">
						<nav class="service-tabs" aria-label="服务类型">
							<button
								v-for="(service, index) in serviceList"
								:key="service.key"
								type="button"
								:class="['service-tab', { 'is-active': activeServiceIndex === index }]"
								:aria-pressed="activeServiceIndex === index"
								@click="activeServiceIndex = index">
								<span class="service-tab__icon">
									<i :class="['iconfont', service.icon]" aria-hidden="true"></i>
								</span>
								<span>{{ service.name }}</span>
								<i class="el-icon-arrow-right service-tab__arrow" aria-hidden="true"></i>
							</button>
						</nav>

						<div class="service-detail">
							<transition name="service-fade" mode="out-in">
								<div :key="activeService.key" class="service-detail__panel">
									<header class="service-hero">
										<div class="service-hero__visual" :style="{ backgroundImage: `url(${activeService.image})` }"></div>
										<div class="service-hero__content">
											<p class="service-hero__eyebrow">SERVICE CAPABILITY</p>
											<h3>服务能力</h3>
											<p class="service-hero__description">{{ activeService.description }}</p>
										</div>
										<el-button class="service-hero__button" @click="handleServiceExperience(activeService.path)">
											前往体验
											<i class="el-icon-right"></i>
										</el-button>
									</header>

									<ul class="service-values">
										<li v-for="(value, index) in activeService.values" :key="value.title" class="service-value">
											<div class="service-value__index">价值{{ chineseNumbers[index] }}</div>
											<div class="service-value__content">
												<div class="service-value__icon">
													<i :class="['iconfont', value.icon]" aria-hidden="true"></i>
												</div>
												<div>
													<h4>{{ value.title }}</h4>
													<p>{{ value.description }}</p>
												</div>
											</div>
										</li>
									</ul>
								</div>
							</transition>
						</div>
					</div>
				</section>

				<!-- 资质宝 -->
				<section class="qualification-treasure-section" aria-labelledby="qualification-treasure-title">
					<div class="qualification-treasure-section__heading">
						<p>QUALIFICATION TREASURE</p>
						<h2 id="qualification-treasure-title">资质宝，让企业资质管理更简单</h2>
						<span>数据真实可靠，诊断精准到位，资质动态及时掌握</span>
					</div>

					<div class="qualification-overview">
						<div class="authority-card">
							<div class="qualification-card-title">
								<span class="qualification-card-title__icon"><i class="iconfont icon-fuwupingtai"></i></span>
								<div>
									<p>DATA AUTHORITY</p>
									<h3>数据权威</h3>
								</div>
							</div>
							<p class="qualification-card-description">
								自动调用权威材料，多维数据交叉核验，再做智能诊断，让结论真实、可信、有据可查。
							</p>
							<div class="authority-card__image">
								<img src="@/assets/index/qualification-authority.jpg" alt="楚建通资质诊断数据结果示例" />
							</div>
						</div>

						<div class="report-card">
							<div class="report-card__header">
								<div class="qualification-card-title">
									<span class="qualification-card-title__icon"><i class="iconfont icon-kanchabaogao"></i></span>
									<div>
										<p>DIAGNOSIS REPORT</p>
										<h3>出具诊断报告</h3>
									</div>
								</div>
								<p class="qualification-card-description">
									报告包含诊断结果、深度分析、整改建议及人才推荐，支持留存与转发，让每一步调整都有方向。
								</p>
							</div>
							<div class="report-stack" aria-label="资质诊断报告示例">
								<div
									v-for="(report, index) in reportList"
									:key="report.title"
									:class="['report-sheet', `report-sheet--${index + 1}`]">
									<img :src="report.image" :alt="report.title" />
								</div>
							</div>
							<div class="report-card__footer">
								<el-button type="primary" class="qualification-action" @click="handleServiceExperience('/mallStore')">
									前往购买
									<i class="el-icon-right"></i>
								</el-button>
							</div>
						</div>
					</div>

					<a
						class="qualification-maintenance-banner"
						href="javascript:;"
						@click.prevent="handleServiceExperience('/qualification/maintenance')">
						<img src="@/assets/qualificationService/maintenance-banner.png" alt="资质维护智能预警服务" />
					</a>

					<div class="maintenance-section">
						<div class="maintenance-section__heading">
							<div>
								<p>QUALIFICATION MAINTENANCE</p>
								<h3>资质维护</h3>
							</div>
							<span>四类动态实时掌握，关键变化不错过</span>
						</div>

						<div class="maintenance-tabs" role="tablist" aria-label="资质维护提醒类型">
							<div
								v-for="(reminder, index) in maintenanceReminderList"
								:key="reminder.key"
								:class="['maintenance-tab', { 'is-active': activeReminderIndex === index }]"
								role="tab"
								tabindex="0"
								:aria-selected="activeReminderIndex === index"
								@click="activeReminderIndex = index"
								@keydown.enter="activeReminderIndex = index"
								@keydown.space.prevent="activeReminderIndex = index">
								<span class="maintenance-tab__icon"><i :class="['iconfont', reminder.icon]"></i></span>
								<span>{{ reminder.name }}</span>
							</div>
						</div>

						<div class="maintenance-content">
							<div class="maintenance-content__summary">
								<span><i class="el-icon-warning-outline"></i></span>
								<p>{{ activeReminder.description }}</p>
							</div>
							<ul class="maintenance-list">
								<li v-for="(item, itemIndex) in activeReminder.items" :key="`${activeReminder.key}-${itemIndex}`">
									<div class="maintenance-list__icon"><i class="iconfont icon-qiye"></i></div>
									<div class="maintenance-list__main">
										<h5>{{ item.name }}</h5>
										<div class="maintenance-list__details">
											<span>资质类别：{{ item.qualificationType }}</span>
											<template v-if="activeReminder.key === 'expiry'">
												<span>注册时间：{{ item.registerTime }}</span>
												<span>有效时间：{{ item.validTime }}</span>
											</template>
											<span v-else>预警时间：{{ item.warningTime }}</span>
										</div>
									</div>
									<div v-if="activeReminder.key === 'expiry'" class="maintenance-list__deadline">
										<span>剩余时间</span>
										<strong>
											{{ item.remainDays }}
											<em>天</em>
										</strong>
									</div>
									<div v-else :class="['maintenance-list__notice', `is-${activeReminder.key}`]">
										<i class="el-icon-warning-outline"></i>
										<span>{{ activeReminder.notice }}</span>
									</div>
								</li>
							</ul>
							<el-button class="maintenance-content__button" @click="handleServiceExperience('/mallStore')">
								前往购买
								<i class="el-icon-right"></i>
							</el-button>
						</div>
					</div>
				</section>

				<!-- 资质查 -->
				<section class="qualification-query-section" aria-labelledby="qualification-query-title">
					<div class="qualification-query-section__heading">
						<p>QUALIFICATION QUERY</p>
						<h2 id="qualification-query-title">资质查</h2>
						<span>汇聚海量数据——让查资质，从“翻档案”变成“秒级查证”</span>
					</div>

					<div class="qualification-query-layout">
						<div class="qualification-query-layout__main">
							<div class="query-entry-panel">
								<div class="query-panel-heading">
									<div>
										<p>ONE-STOP QUERY</p>
										<h3>查企业、查人员、查项目</h3>
									</div>
									<span>一键查询企业资质、人员执业资格、项目备案与中标信息，覆盖建筑资信全对象</span>
								</div>
								<div class="query-entry-list">
									<div
										v-for="entry in qualificationQueryEntries"
										:key="entry.name"
										class="query-entry-item"
										role="link"
										tabindex="0"
										@click="handleServiceExperience(entry.path)"
										@keydown.enter="handleServiceExperience(entry.path)"
										@keydown.space.prevent="handleServiceExperience(entry.path)">
										<span :class="['query-entry-item__icon', `is-${entry.key}`]">
											<i :class="['iconfont', entry.icon]"></i>
										</span>
										<div>
											<h4>{{ entry.name }}</h4>
											<p>{{ entry.description }}</p>
										</div>
										<i class="el-icon-right query-entry-item__arrow"></i>
									</div>
								</div>
							</div>

							<div class="project-stage-panel">
								<div class="query-panel-heading">
									<div>
										<p>PROJECT PROCESS</p>
										<h3>项目阶段</h3>
									</div>
									<span>从招标到竣工，关键阶段与备案信息一览看清</span>
								</div>
								<div class="project-stage-flow" aria-label="项目建设阶段流程">
									<div
										v-for="stage in projectStageList"
										:key="stage.name"
										class="project-stage-item"
										:style="{ '--stage-color': stage.color }">
										<div class="project-stage-item__title">
											<span>{{ stage.name }}</span>
										</div>
										<div class="project-stage-item__content">
											<div v-for="item in stage.items" :key="item" class="project-stage-item__node">
												{{ item }}
											</div>
										</div>
									</div>
								</div>
								<el-button class="qualification-query-action" @click="handleServiceExperience('/qualification-query/project')">
									立即前往
									<i class="el-icon-right"></i>
								</el-button>
							</div>
						</div>

						<div class="analysis-panel">
							<div class="query-panel-heading query-panel-heading--analysis">
								<div>
									<p>DATA ANALYSIS</p>
									<h3>人员、企业分析</h3>
								</div>
								<span>人员技能与风险、企业资质与业绩，多维数据辅助判断</span>
							</div>
							<div class="analysis-tags">
								<span>
									<i class="iconfont icon-user"></i>
									人员画像
								</span>
								<span>
									<i class="iconfont icon-qiye"></i>
									企业画像
								</span>
							</div>

							<div class="analysis-chart-card risk-analysis-chart">
								<div class="analysis-chart-card__heading">
									<h4>风险分析</h4>
									<span>风险指标综合评估</span>
								</div>
								<div class="risk-gauge">
									<svg viewBox="0 0 240 132" aria-label="风险分析得分68%">
										<path class="risk-gauge__track" pathLength="100" d="M 28 112 A 92 92 0 0 1 212 112" />
										<path class="risk-gauge__value" pathLength="100" d="M 28 112 A 92 92 0 0 1 212 112" />
									</svg>
									<div class="risk-gauge__value-text">
										<strong>68</strong>
										<span>%</span>
										<em>风险可控</em>
									</div>
									<span class="risk-gauge__min">0%</span>
									<span class="risk-gauge__max">100%</span>
								</div>
							</div>

							<div class="analysis-chart-card skill-analysis-chart">
								<div class="analysis-chart-card__heading">
									<h4>技能级别统计</h4>
									<span>1级—5级能力占比</span>
								</div>
								<svg class="skill-chart" viewBox="0 0 310 150" aria-label="技能级别占比折线图">
									<defs>
										<linearGradient id="skillAreaGradient" x1="0" y1="0" x2="0" y2="1">
											<stop offset="0%" stop-color="#4c92e5" stop-opacity="0.32" />
											<stop offset="100%" stop-color="#4c92e5" stop-opacity="0.02" />
										</linearGradient>
									</defs>
									<line
										v-for="lineY in [28, 68, 108]"
										:key="lineY"
										x1="18"
										:y1="lineY"
										x2="292"
										:y2="lineY"
										class="skill-chart__grid" />
									<polygon points="24,104 89,84 154,74 219,93 284,106 284,118 24,118" fill="url(#skillAreaGradient)" />
									<polyline points="24,104 89,84 154,74 219,93 284,106" class="skill-chart__line" />
									<g v-for="(level, index) in skillLevelList" :key="level.name">
										<circle :cx="24 + index * 65" :cy="level.y" r="4" class="skill-chart__point" />
										<text :x="24 + index * 65" :y="level.y - 10" class="skill-chart__percent">{{ level.value }}%</text>
										<text :x="24 + index * 65" y="140" class="skill-chart__label">{{ level.name }}</text>
									</g>
								</svg>
							</div>

							<el-button
								class="qualification-query-action qualification-query-action--analysis"
								@click="handleServiceExperience('/qualification-query/company')">
								立即前往
								<i class="el-icon-right"></i>
							</el-button>
						</div>
					</div>
				</section>

				<!-- 广告宣传投放 -->
				<section class="advertising-section" aria-labelledby="advertising-title">
					<div class="advertising-section__heading">
						<p>BRAND PROMOTION</p>
						<h2 id="advertising-title">广告宣传投放</h2>
						<span>
							聚焦企业
							<strong>品牌形象</strong>
							与
							<strong>实力展示</strong>
							，把企业“
							<strong>好看的一面</strong>
							”做成版面，长期在专栏亮相
						</span>
					</div>

					<div class="advertising-showcase">
						<div class="custom-layout-card">
							<div class="custom-layout-card__content">
								<div class="advertising-card-heading">
									<p>CUSTOMIZED PAGE</p>
									<h3>专属企业定制化版面</h3>
									<span>专业团队，深度调研，打造专属版面方案，助力企业展示</span>
								</div>
								<ul class="custom-feature-list">
									<li v-for="item in advertisingCustomizationList" :key="item.title" class="custom-feature-item">
										<span class="custom-feature-item__icon"><i :class="['iconfont', item.icon]"></i></span>
										<div>
											<h4>{{ item.title }}</h4>
											<p>{{ item.description }}</p>
										</div>
									</li>
								</ul>
								<el-button class="advertising-action advertising-action--contact" @click="openQQService">
									立即联系
									<i class="el-icon-right"></i>
								</el-button>
							</div>
						</div>

						<div class="promotion-placement-card">
							<div class="advertising-card-heading advertising-card-heading--promotion">
								<p>BRAND EXPOSURE</p>
								<h3>企业宣传、风采投放</h3>
								<span>权威官方平台 + 行业精准流量 + 品牌信任加持</span>
							</div>
							<div class="promotion-placement-card__visual">
								<img src="@/assets/index/advertising-placement.jpg" alt="企业宣传与风采投放版面示例" />
								<span>企业宣传专栏展示示例</span>
							</div>
							<el-button class="advertising-action advertising-action--purchase" @click="handleServiceExperience('/mallStore')">
								前往购买
								<i class="el-icon-right"></i>
							</el-button>
						</div>
					</div>
				</section>

				<!-- 人才库专区 -->
				<section class="talent-zone-section" aria-labelledby="talent-zone-title">
					<div class="talent-zone-overview">
						<div class="talent-pool-panel">
							<div class="talent-panel-heading">
								<div>
									<p>MASSIVE TALENT POOL</p>
									<h3>海量人才推介</h3>
								</div>
								<span>多维人才标签，快速锁定合适人选</span>
							</div>
							<div class="talent-profile-grid">
								<div
									v-for="(talent, index) in talentShowcaseList"
									:key="talent.name + index"
									class="talent-profile-card"
									role="link"
									tabindex="0"
									@click="handleServiceExperience('/employment/recommend')"
									@keydown.enter="handleServiceExperience('/employment/recommend')">
									<div class="talent-profile-card__avatar">
										<img src="@/assets/index/index-zw2.png" :alt="`${talent.name}人才头像`" />
										<span>{{ talent.status }}</span>
									</div>
									<div class="talent-profile-card__content">
										<div class="talent-profile-card__title">
											<h4>{{ talent.name }}</h4>
										</div>
										<p>{{ talent.position }}</p>
										<div class="talent-profile-card__tags">
											<span>{{ talent.age }}</span>
											<span>{{ talent.education }}</span>
											<span>{{ talent.experience }}</span>
										</div>
										<small>
											<b>专业证书</b>
											{{ talent.certificates }}
										</small>
										<small class="talent-profile-card__skills">
											<b>技能简介</b>
											{{ talent.skills }}
										</small>
									</div>
								</div>
							</div>
							<div class="talent-pool-capabilities">
								<div class="talent-pool-capabilities__heading">
									<span>人才库服务能力</span>
									<small>从筛选到核验，让人才选择更高效</small>
								</div>
								<div class="talent-pool-capabilities__list">
									<div>
										<i class="el-icon-circle-check"></i>
										<span>认证人才优先</span>
									</div>
									<div>
										<i class="el-icon-s-operation"></i>
										<span>多维标签筛选</span>
									</div>
									<div>
										<i class="el-icon-connection"></i>
										<span>智能岗位匹配</span>
									</div>
									<div>
										<i class="el-icon-refresh"></i>
										<span>人才状态更新</span>
									</div>
								</div>
							</div>
							<el-button class="talent-zone-action" @click="handleServiceExperience('/employment/recruitment-center')">
								查看更多人才
								<i class="el-icon-right"></i>
							</el-button>
						</div>

						<div class="talent-zone-overview__side">
							<div class="talent-zone-section__heading">
								<p>TALENT DATABASE</p>
								<h2 id="talent-zone-title">人才库专区</h2>
								<strong>好人才，精准遇对人</strong>
								<span>建筑人才精准匹配第一选择，为万千认证建企量身打造</span>
							</div>

							<div class="talent-connection-panel">
								<div class="talent-panel-heading talent-panel-heading--connection">
									<div>
										<p>DUAL CONNECTION</p>
										<h3>主动 + 被动双线</h3>
									</div>
									<span>下载简历、接收投递、人才推介全打通</span>
								</div>
								<div class="connection-flow">
									<div class="connection-flow__node is-company">
										<i class="iconfont icon-qiye"></i>
										<span>认证企业</span>
									</div>
									<div class="connection-flow__bridge">
										<span class="is-forward"><i class="el-icon-right"></i></span>
										<strong>双向精准撮合</strong>
										<span class="is-backward"><i class="el-icon-back"></i></span>
									</div>
									<div class="connection-flow__node is-talent">
										<i class="iconfont icon-user"></i>
										<span>优质人才</span>
									</div>
								</div>
								<div class="connection-service-list">
									<div>
										<i class="el-icon-search"></i>
										<span>主动检索人才</span>
									</div>
									<div>
										<i class="el-icon-document"></i>
										<span>索要完整简历</span>
									</div>
									<div>
										<i class="el-icon-message"></i>
										<span>接收人才投递</span>
									</div>
									<div>
										<i class="el-icon-s-promotion"></i>
										<span>平台定向推介</span>
									</div>
								</div>
								<div class="connection-note">
									<i class="el-icon-info"></i>
									<p>联系方式与简历在双方授权后可见，支持意向确认与婉拒反馈，让每一次连接更专业。</p>
								</div>
								<el-button
									class="talent-zone-action talent-zone-action--primary"
									@click="handleServiceExperience('/employment/recruitment-center')">
									进入人才专区
									<i class="el-icon-right"></i>
								</el-button>
							</div>
						</div>
					</div>

					<div class="talent-insight-layout">
						<div class="talent-comparison-panel">
							<div class="talent-panel-heading">
								<div>
									<p>TALENT COMPARISON</p>
									<h3>人员对比</h3>
								</div>
								<span>优势、技能、稳定性，横向比出最优人选</span>
							</div>
							<div class="comparison-profile">
								<img src="@/assets/index/index-zw2.png" alt="张某某人才头像" />
								<div>
									<p>
										<strong>张某某</strong>
										<span>人才库</span>
										<span>在职</span>
									</p>
									<h4>PMC注册安全工程师</h4>
									<small>25岁 · 本科 · 3年经验 · 武汉</small>
								</div>
								<em>15k~20k/月</em>
							</div>
							<div class="comparison-metrics">
								<div v-for="metric in talentComparisonMetrics" :key="metric.name" class="comparison-metric">
									<div>
										<span>{{ metric.name }}</span>
										<strong>{{ metric.value }}%</strong>
									</div>
									<p><i :style="{ width: `${metric.value}%` }"></i></p>
								</div>
							</div>
						</div>

						<div class="talent-background-panel">
							<div class="talent-panel-heading talent-panel-heading--background">
								<div>
									<p>QUALIFICATION CHECK</p>
									<h3>资质背调</h3>
								</div>
								<span>官方口径核验人员资质，招聘更安心</span>
							</div>
							<div class="background-dimension-tabs" role="tablist" aria-label="资质背调维度">
								<div
									v-for="(dimension, index) in talentBackgroundDimensions"
									:key="dimension.key"
									:class="['background-dimension-tab', { 'is-active': activeTalentBackgroundIndex === index }]"
									role="tab"
									tabindex="0"
									:aria-selected="activeTalentBackgroundIndex === index"
									@click="activeTalentBackgroundIndex = index"
									@keydown.enter="activeTalentBackgroundIndex = index">
									<i :class="['iconfont', dimension.icon]"></i>
									<span>{{ dimension.name }}</span>
								</div>
							</div>
							<div class="background-dimension-preview">
								<div class="background-dimension-preview__summary">
									<span><i :class="['iconfont', activeTalentBackgroundDimension.icon]"></i></span>
									<div>
										<small>当前核验维度</small>
										<h4>{{ activeTalentBackgroundDimension.name }}</h4>
										<p>{{ activeTalentBackgroundDimension.description }}</p>
									</div>
								</div>
								<ul class="background-field-list">
									<li v-for="field in activeTalentBackgroundDimension.fields" :key="field">
										<i class="el-icon-check"></i>
										{{ field }}
									</li>
								</ul>
								<div class="background-trust-tags">
									<span>
										<i class="el-icon-circle-check"></i>
										官方数据口径
									</span>
									<span>
										<i class="el-icon-lock"></i>
										授权安全查询
									</span>
									<span>
										<i class="el-icon-time"></i>
										结果实时更新
									</span>
								</div>
							</div>
							<el-button
								class="talent-zone-action talent-zone-action--background"
								@click="handleServiceExperience('/employment/index')">
								前往使用
								<i class="el-icon-right"></i>
							</el-button>
						</div>
					</div>
				</section>

				<!-- 后续首页业务模块将在此区域逐步补充 -->
			</div>

			<!-- 对比 -->
			<section class="contrast-section" aria-label="楚建通与其他网站服务对比">
				<div class="service-comparison">
					<div class="service-comparison__spine">
						<img class="service-comparison__vs" src="@/assets/index/vs-badge.png" alt="VS" />
					</div>
					<div class="service-comparison__headers">
						<div class="service-comparison__brand is-cjt">
							<span><i class="iconfont icon-fuwupingtai"></i></span>
							<strong>楚建通</strong>
						</div>
						<div></div>
						<div class="service-comparison__brand is-other">
							<span><i class="el-icon-monitor"></i></span>
							<strong>其他网站</strong>
						</div>
					</div>
					<ul class="service-comparison__rows">
						<li v-for="item in serviceComparisonList" :key="item.dimension" class="service-comparison__row">
							<div class="service-comparison__value is-cjt">
								<span>{{ item.advantage }}</span>
								<p>{{ item.cjt }}</p>
							</div>
							<div class="service-comparison__dimension">
								<i class="is-left"></i>
								<strong>{{ item.dimension }}</strong>
								<i class="is-right"></i>
							</div>
							<div class="service-comparison__value is-other">
								<span>{{ item.disadvantage }}</span>
								<p>{{ item.other }}</p>
							</div>
						</li>
					</ul>
				</div>
			</section>

			<!-- 联系我们 -->
			<section v-if="showContact" class="contact-section">
				<div class="contact-phone">
					<p>联系我们享优惠</p>
					<p class="phone">电话：400-992-5998</p>
				</div>
				<ul class="contact-methods">
					<li v-for="item in contactMethods" :key="item.title">
						<div>
							<p class="title">{{ item.title }}</p>
							<p class="description">{{ item.description }}</p>
						</div>
						<el-button class="contact-button" type="primary" @click="openQQService">
							{{ item.buttonText }}
						</el-button>
					</li>
				</ul>
				<button class="contact-close" type="button" aria-label="关闭联系我们" @click="showContact = false">
					<i class="el-icon-close"></i>
				</button>
			</section>
		</main>

		<!-- 侧栏功能 -->
		<aside class="function-sidebar" aria-label="快捷服务" @mouseleave="isFunctionMenuVisible = false">
			<div class="function-sidebar__trigger" @mouseenter="isFunctionMenuVisible = true">
				<img src="@/assets/index/function/people.png" alt="" />
			</div>
			<span class="function-sidebar__title">在线管家</span>
			<ul :class="['function-sidebar__menu', { 'is-visible': isFunctionMenuVisible }]">
				<li @click="openQQService">
					<svg-icon icon-class="guidance" />
					<span>联系我们</span>
				</li>
				<li @click="handleLocationCouponCenter">
					<i class="el-icon-present"></i>
					<span>领券中心</span>
				</li>
				<li @click="handleLocationMallStore">
					<i class="el-icon-shopping-bag-1"></i>
					<span>商城</span>
				</li>
				<li @click="handleLocationTicket">
					<svg-icon icon-class="ticket" />
					<span>开发票</span>
				</li>
				<!-- <li @click="handleLocationMember">
					<svg-icon icon-class="vip" />
					<span>会员权益</span>
				</li> -->
				<li @click="handleScrollTop">
					<i class="el-icon-top"></i>
					<span>置顶</span>
				</li>
			</ul>
		</aside>

		<!-- 底部服务向导与页脚 -->
		<footer-guide />
		<page-footer />
	</div>
</template>

<script>
	import Swiper from 'swiper'
	import CountTo from 'vue-count-to'
	import 'swiper/css/swiper.css'
	import TopNavHead from '@/components/TopNavHead'
	import FooterGuide from '@/components/FooterGuide'
	import PageFooter from '@/components/PageFooter'
	import QQService from '@/mixins/QQService'
	import { homeCountTotal } from '@/api/qualificationQuery/person'

	export default {
		name: 'NewIndex',
		components: {
			TopNavHead,
			FooterGuide,
			PageFooter,
			CountTo
		},
		mixins: [QQService],
		data() {
			return {
				bannerSwiper: null,
				bannerList: [
					{
						title: '楚建通一站式服务平台',
						imageUrl: require('@/assets/index/banner/banner-index01.jpg')
					}
				],
				homeTotalInfo: {},
				activeServiceIndex: 0,
				chineseNumbers: ['一', '二', '三', '四'],
				reportList: [
					{ title: '建筑业资质诊断报告封面', image: require('@/assets/report/report-1.jpg') },
					{ title: '建筑业资质诊断明细', image: require('@/assets/report/report-2.jpg') },
					{ title: '建筑业资质诊断结论', image: require('@/assets/report/report-3.jpg') }
				],
				activeReminderIndex: 0,
				maintenanceReminderList: [
					{
						key: 'expiry',
						name: '临期提醒',
						icon: 'icon-shizhongfill',
						description: '资质快到期前主动告诉你，别等资质办理才发现资质已失效，事后救火，来不及！',
						items: [
							{
								type: '1',
								name: '建筑业企业资质证书',
								qualificationType: '********',
								registerTime: '20**-**-**',
								validTime: '20**-**-**',
								remainDays: 30
							},
							{
								type: '2',
								name: '建设工程设计企业资质证书',
								qualificationType: '********',
								registerTime: '20**-**-**',
								validTime: '20**-**-**',
								remainDays: 60
							},
							{
								type: '3',
								name: '建设工程勘察企业资质证书',
								qualificationType: '********',
								registerTime: '20**-**-**',
								validTime: '20**-**-**',
								remainDays: 90
							},
							{
								type: '4',
								name: '建设工程质量检测机构资质证书',
								qualificationType: '********',
								registerTime: '20**-**-**',
								validTime: '20**-**-**',
								remainDays: 100
							}
						]
					},
					{
						key: 'cancellation',
						name: '注销提醒',
						icon: 'icon-guanbianniu',
						description: '资质被注销、撤销即时告警，防止“资质没了还蒙在鼓里”错过补救。',
						notice: '可能存在不满足当前资质条件风险',
						items: [
							{ name: '建筑业企业资质证书', qualificationType: '********', warningTime: '20**-**-**' },
							{ name: '建设工程设计企业资质证书', qualificationType: '********', warningTime: '20**-**-**' },
							{ name: '建设工程勘察企业资质证书', qualificationType: '********', warningTime: '20**-**-**' },
							{ name: '建设工程质量检测机构资质证书', qualificationType: '********', warningTime: '20**-**-**' }
						]
					},
					{
						key: 'registration',
						name: '注册提醒',
						icon: 'icon-zizhixinban',
						description: '新资质、人员注册一落地就通知，企业新增实力第一时间掌握。',
						notice: '可能存在升级或更新延续条件',
						items: [
							{ name: '建筑业企业资质证书', qualificationType: '********', warningTime: '20**-**-**' },
							{ name: '建设工程设计企业资质证书', qualificationType: '********', warningTime: '20**-**-**' },
							{ name: '建设工程勘察企业资质证书', qualificationType: '********', warningTime: '20**-**-**' },
							{ name: '建设工程质量检测机构资质证书', qualificationType: '********', warningTime: '20**-**-**' }
						]
					},
					{
						key: 'risk',
						name: '风险提醒',
						icon: 'icon-yujing1',
						description: '行政处罚、黑名单、联合惩戒等风险变动实时推送，合作投标前心里有底。',
						notice: '企业存在一条不良记录，可能影响资质办理、资质更新延续、资质升级',
						items: [
							{ name: '建筑业企业资质证书', qualificationType: '********', warningTime: '20**-**-**' },
							{ name: '建设工程设计企业资质证书', qualificationType: '********', warningTime: '20**-**-**' },
							{ name: '建设工程勘察企业资质证书', qualificationType: '********', warningTime: '20**-**-**' },
							{ name: '建设工程质量检测机构资质证书', qualificationType: '********', warningTime: '20**-**-**' }
						]
					}
				],
				qualificationQueryEntries: [
					{
						key: 'company',
						name: '查企业',
						icon: 'icon-qiye',
						description: '资质等级、信用记录与经营风险一屏掌握',
						path: '/qualification-query/company'
					},
					{
						key: 'person',
						name: '查人员',
						icon: 'icon-user',
						description: '执业资格、注册状态与项目履历快速核验',
						path: '/qualification-query/person'
					},
					{
						key: 'project',
						name: '查项目',
						icon: 'icon-xiangmu',
						description: '备案、中标及建设全过程信息一站查询',
						path: '/qualification-query/project'
					},
					{
						key: 'advanced',
						name: '高级查询',
						icon: 'icon-chakan',
						description: '多条件组合筛选，快速定位目标数据',
						path: '/qualification-query/company'
					}
				],
				projectStageList: [
					{ name: '招投标阶段', items: ['招投标信息'], color: '#4bb8eb' },
					{ name: '合同签约阶段', items: ['施工图审查'], color: '#4b9eeb' },
					{ name: '实施阶段', items: ['施工许可', '现场管理人员'], color: '#2fb96d' },
					{ name: '验收阶段', items: ['竣工验收', '竣工验收备案'], color: '#38c6c4' },
					{ name: '业绩评价', items: ['业绩技术指标'], color: '#015bb6' }
				],
				skillLevelList: [
					{ name: '1级', value: 12, y: 104 },
					{ name: '2级', value: 26, y: 84 },
					{ name: '3级', value: 34, y: 74 },
					{ name: '4级', value: 18, y: 93 },
					{ name: '5级', value: 10, y: 106 }
				],
				advertisingCustomizationList: [
					{
						title: '需求洞察',
						description: '专人对接，深挖企业定位、展示重点与品牌调性诉求',
						icon: 'icon-guwenzixun'
					},
					{
						title: '专业定制版面',
						description: '设计团队按客户需求 1 对 1 量身定制，拒绝套模板',
						icon: 'icon-bianjiwenjian'
					},
					{
						title: '板块按需组合',
						description: '企业简介、荣誉墙、经典案例、团队风采等模块，按客户意愿取舍与排序',
						icon: 'icon-fuwupingtai'
					},
					{
						title: '多形态专业呈现',
						description: '图文、视频、时间轴按内容特质定制排布，呈现更专业',
						icon: 'icon-fenxiangweifenxiang'
					}
				],
				talentShowcaseList: [
					{
						name: '张某某',
						position: 'PMC注册安全工程师',
						age: '25岁',
						education: '本科',
						experience: '3年',
						status: '随时到岗',
						certificates: '建筑电工、建筑架子工',
						skills: '熟练操作设计相关软件，掌握施工安全管理流程'
					},
					{
						name: '李某某',
						position: '一级建造师',
						age: '32岁',
						education: '本科',
						experience: '8年',
						status: '在职',
						certificates: '一级建造师、安全B证',
						skills: '擅长施工组织、进度统筹与多专业协同管理'
					},
					{
						name: '王某某',
						position: '注册监理工程师',
						age: '29岁',
						education: '本科',
						experience: '5年',
						status: '随时到岗',
						certificates: '监理工程师、中级职称',
						skills: '熟悉质量验收规范，具备现场风险识别能力'
					},
					{
						name: '陈某某',
						position: '造价工程师',
						age: '30岁',
						education: '本科',
						experience: '6年',
						status: '在职',
						certificates: '一级造价师、咨询工程师',
						skills: '熟练使用造价软件，擅长成本测算与结算审核'
					},
					{
						name: '刘某某',
						position: '建筑结构工程师',
						age: '28岁',
						education: '硕士',
						experience: '4年',
						status: '随时到岗',
						certificates: '一级结构师、高级职称',
						skills: '熟练使用结构设计软件，具备复杂结构分析经验'
					},
					{
						name: '赵某某',
						position: '项目技术负责人',
						age: '35岁',
						education: '本科',
						experience: '10年',
						status: '在职',
						certificates: '一级建造师、安全B证',
						skills: '擅长技术方案编制、图纸会审与现场技术协调'
					}
				],
				talentComparisonMetrics: [
					{ name: '岗位匹配', value: 92 },
					{ name: '技能资质', value: 88 },
					{ name: '项目经验', value: 86 },
					{ name: '履历稳定', value: 90 }
				],
				activeTalentBackgroundIndex: 0,
				talentBackgroundDimensions: [
					{
						key: 'registration',
						name: '注册信息',
						icon: 'icon-zizhixinban',
						description: '核验人员注册证书、执业单位和证书有效状态。',
						fields: ['证书名称', '注册单位', '注册专业', '注册日期', '有效期']
					},
					{
						key: 'non-registration',
						name: '非注册信息',
						icon: 'icon-kanchabaogao',
						description: '查看非注册类专业证书及其编号、类型与有效状态。',
						fields: ['证书名称', '证书类型', '证书编号', '有效期']
					},
					{
						key: 'project-performance',
						name: '个人工程业绩',
						icon: 'icon-xiangmu',
						description: '追溯人员参与项目的名称、类别、编码和所在地区。',
						fields: ['项目名称', '项目地址', '工程类别', '项目编码', '所属地区']
					},
					{
						key: 'technical-index',
						name: '业绩技术指标',
						icon: 'icon-fuwupingtai',
						description: '核验个人业绩记录、项目编码及其在工程中的实际作用。',
						fields: ['项目名称', '个人业绩记录编号', '项目编码', '本人在工程中所起作用', '数据等级']
					},
					{
						key: 'good-behavior',
						name: '良好行为',
						icon: 'icon-fenxiangweifenxiang',
						description: '了解人员诚信表彰、决定内容与有效期限。',
						fields: ['诚信记录主体及编号', '决定内容', '实施部门', '决定日期与有效期']
					},
					{
						key: 'bad-behavior',
						name: '不良行为',
						icon: 'icon-yujing1',
						description: '识别人员历史不良诚信记录及相关实施部门。',
						fields: ['诚信记录主体及编号', '决定内容', '实施部门', '决定日期与有效期']
					},
					{
						key: 'administrative-penalty',
						name: '行政处罚',
						icon: 'icon-guanbianniu',
						description: '查询行政处罚主体、处罚内容及登记信息。',
						fields: ['行政处罚主体及编号', '内容描述', '登记部门', '登记时间']
					}
				],
				serviceComparisonList: [
					{
						dimension: '价格',
						advantage: '低',
						cjt: '价格透明，低廉，性价比高',
						disadvantage: '高',
						other: '价格虚高，处处收费'
					},
					{ dimension: '操作', advantage: '易', cjt: '一站式服务，操作便捷', disadvantage: '难', other: '服务零散，操作麻烦' },
					{
						dimension: '服务',
						advantage: '好',
						cjt: '平台管家，专业客服随时处理各类问题',
						disadvantage: '坏',
						other: '无平台管家服务，业余客服难以应对'
					},
					{
						dimension: '数据',
						advantage: '真',
						cjt: '信息丰富且真实可靠，数据海量全面',
						disadvantage: '假',
						other: '信息匮乏且虚假难辨，数据稀缺片面'
					},
					{
						dimension: '能力',
						advantage: '专',
						cjt: '专业诊断服务，精准诊断结果',
						disadvantage: '泛',
						other: '非专业诊断服务，模糊诊断结果'
					}
				],
				serviceList: [
					{
						key: 'qualification-service',
						name: '资质宝',
						icon: 'icon-zizhixinban',
						path: '/qualification/index',
						image: require('@/assets/qualificationService/banner-index01.jpg'),
						description: '为认证企业量身打造的资质管家，围绕“预警—诊断—报告”三大能力展开。',
						values: [
							{
								title: '资质预警',
								description: '委托系统对资质做临期、注销、注册、风险四类提醒，关键节点不漏接。',
								icon: 'icon-yujing'
							},
							{
								title: '资质诊断',
								description: '一键诊断企业资质现状，自动得出诊断结果，定位资质缺口与风险点。',
								icon: 'icon-zhenduan'
							},
							{
								title: '出具资质诊断报告',
								description: '下载专属诊断报告，内容涵盖诊断结果、深度分析、整改建议等，可留存可转发。',
								icon: 'icon-kanchabaogao'
							},
							{
								title: '自定义资质预警',
								description: '个性化定制预警提示频率，按企业管理节奏灵活设置。',
								icon: 'icon-zizhiweihu'
							}
						]
					},
					{
						key: 'qualification-query',
						name: '资质查',
						icon: 'icon-chakan',
						path: '/qualification-query/company',
						image: require('@/assets/qualificationQuery/banner-index01.jpg'),
						description: '个人、企业、项目一站查透！人员画像定位实力，企业资质透视风险，项目脉络全程溯源。查得准，合作才敢信。',
						values: [
							{
								title: '精准识人',
								description: '人员画像＋深度分析，让人才真相无所遁形。从执业资格到项目履历，一眼看穿真实水平。',
								icon: 'icon-user'
							},
							{
								title: '企业体检',
								description: '资质风险一键查，合作前先吃颗定心丸。资质等级、信用记录、经营异常，一屏看全。',
								icon: 'icon-qiye'
							},
							{
								title: '项目穿透',
								description: '全周期资质溯源，烂尾隐患提前预警。从立项到竣工，关键节点链条可查、风险可判。',
								icon: 'icon-xiangmu'
							},
							{
								title: '数据全景',
								description: '全面、真实、一站可达。人员、企业、项目底细一屏打通，告别到处翻材料，一次查询，全局在握。',
								icon: 'icon-fuwupingtai'
							}
						]
					},
					{
						key: 'talent-market',
						name: '人才市场',
						icon: 'icon-rencaizhaopin',
						path: '/employment/index',
						image: require('@/assets/employment/employment-banner.jpg'),
						description:
							'招人、求职一站搞定！企业端发布岗位、人才画像多维比对、在线背调交叉核验，让录用决策有据可依；求职端智能匹配，好岗位自动推送上门。让对的人，遇见对的位置。',
						values: [
							{
								title: '慧眼识才',
								description: '人才画像多维比对，优中选优不再靠感觉。能力标签、项目履历横向PK，谁更合适一目了然。',
								icon: 'icon-rencaizhaopin'
							},
							{
								title: '背景透明',
								description: '在线背调一键发起，履历真伪一查便知。执业资格、从业记录交叉核验，把“注水简历”挡在门外。',
								icon: 'icon-resume-s'
							},
							{
								title: '岗位速配',
								description: '智能匹配精准推送，好工作主动找上门。简历一次完善，合适岗位自己找你，不必大海捞针。',
								icon: 'icon-zhaopin'
							},
							{
								title: '双向直达',
								description: '招人求职一站对接，让对的人遇见对的位置。企业找得快、人才选得准，撮合效率翻倍。',
								icon: 'icon-lijitoudi'
							}
						]
					},
					{
						key: 'advertising',
						name: '广告宣传',
						icon: 'icon-gongwenbao',
						path: '/mallStore/index',
						image: require('@/assets/index/service-advertising-hero.jpg'),
						description:
							'为企业提供全方位品牌展示服务。涵盖企业宣传与风采宣传两大板块，支持版面资源灵活组合，精准触达行业目标人群。更多宣传形式，欢迎与我们联系，为您量身定制。',
						values: [
							{
								title: '品牌亮相',
								description: '企业宣传塑造专业形象，让企业被行业看见。资质实力、业务范围一页讲清，客户找上门之前先记住你。',
								icon: 'icon-qiye'
							},
							{
								title: '风采出圈',
								description: '展示真实一面，让实力被看见、被感知。团队面貌、项目成果、一线故事，讲一个有温度的品牌。',
								icon: 'icon-fenxiangweifenxiang'
							},
							{
								title: '版面定制',
								description: '专题推荐、定向推送、版面资源自由组合。想要什么版面就有什么版面，曝光节奏自己说了算。',
								icon: 'icon-bianjiwenjian'
							},
							{
								title: '专属方案',
								description: '还有别的宣传玩法？欢迎随时联系我们。从创意策划到落地投放，为您量身定制一整套传播方案。',
								icon: 'icon-guwenzixun'
							}
						]
					}
				],
				showContact: true,
				isFunctionMenuVisible: true,
				contactMethods: [
					{
						title: '在线客服',
						description: '实时沟通解决您的问题和需求',
						buttonText: '立即沟通'
					},
					{
						title: '专业顾问',
						description: '为您解决烦忧-24小时在线',
						buttonText: '立即咨询'
					},
					{
						title: '投诉建议',
						description: '提供专业服务-尽心听取意见',
						buttonText: '投诉建议'
					}
				]
			}
		},
		computed: {
			activeReminder() {
				return this.maintenanceReminderList[this.activeReminderIndex]
			},
			activeService() {
				return this.serviceList[this.activeServiceIndex]
			},
			activeTalentBackgroundDimension() {
				return this.talentBackgroundDimensions[this.activeTalentBackgroundIndex]
			},
			statisticsList() {
				return [
					{
						key: 'company',
						label: '企业数',
						icon: 'icon-qiye',
						value: this.getStatisticsValue(['companyCount']),
						unit: '家'
					},
					{
						key: 'person',
						label: '人员数',
						icon: 'icon-user',
						value: this.getStatisticsValue(['personCount']),
						unit: '人'
					},
					{
						key: 'project',
						label: '项目数',
						icon: 'icon-xiangmu',
						value: this.getStatisticsValue(['projectCount']),
						unit: '个'
					},
					{
						key: 'talent',
						label: '人才数',
						icon: 'icon-rencaizhaopin',
						value: this.getStatisticsValue(['talentCount', 'resumeCount']),
						unit: '人'
					},
					{
						key: 'service',
						label: '服务数',
						icon: 'icon-fuwupingtai',
						// value: this.getStatisticsValue(['serviceCount', 'productCount']),
						// 临时值，后续根据需求调整
						value: 7,
						unit: '项'
					}
				]
			}
		},
		created() {
			this.initHomeTotal()
		},
		mounted() {
			this.$nextTick(() => {
				this.bannerSwiper = new Swiper(this.$refs.bannerSwiper, {
					loop: this.bannerList.length > 1,
					autoplay: {
						delay: 5000,
						disableOnInteraction: false
					},
					navigation: {
						nextEl: this.$refs.bannerSwiper.querySelector('.swiper-button-next'),
						prevEl: this.$refs.bannerSwiper.querySelector('.swiper-button-prev')
					}
				})
			})
		},
		beforeDestroy() {
			if (this.bannerSwiper) {
				this.bannerSwiper.destroy(true, true)
				this.bannerSwiper = null
			}
		},
		methods: {
			handleServiceExperience(path) {
				if (path && this.$route.path !== path) {
					this.$router.push(path)
				}
			},
			initHomeTotal() {
				homeCountTotal()
					.then(response => {
						this.homeTotalInfo = response.data || {}
					})
					.catch(() => {
						this.homeTotalInfo = {}
					})
			},
			getStatisticsValue(keys) {
				const matchedKey = keys.find(key => this.homeTotalInfo[key] !== undefined && this.homeTotalInfo[key] !== null)
				const value = matchedKey ? Number(this.homeTotalInfo[matchedKey]) : 0
				return Number.isFinite(value) ? value : 0
			},
			openQQService() {
				this.handleEvokeQQ()
			},
			handleLocationTicket() {
				this.$router.push('/user/invoiceManagement/myInvoice')
			},
			handleLocationMember() {
				this.$router.push('/member-benefits')
			},
			handleLocationCouponCenter() {
				this.$router.push('/coupon-center')
			},
			handleLocationMallStore() {
				this.$router.push('/mallStore')
			},
			handleScrollTop() {
				window.scrollTo({ top: 0, behavior: 'smooth' })
			}
		}
	}
</script>

<style lang="scss" scoped>
	@import './newIndex.scss';
</style>
